import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-header-minimal',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    RouterModule
  ],
  templateUrl: './header-minimal.component.html',
  styleUrl: './header-minimal.component.scss'
})
export class HeaderMinimalComponent {
  onClickScroll(element) {
    const scrollElement = document.querySelector(element).nextSibling.nextElementSibling;
    scrollElement.setAttribute('tabindex', '-1');
    scrollElement.scrollIntoView();
    scrollElement.focus();
  }
}
